const csvTemplate = `outlet_code,brand_id
F2F-00002-02SL0001255,5f92628d91fef2cec7caa35d
F2F-00002-02SL0001255,5d3ac306a6992471b7c97976
F2F-00002-02SL0001255,5d3ac307a6992471b7c97adc
VST-00004-AFO2504001,5d3ac307a6992471b7c97a18
VST-00004-AFO2504001,5f92628d91fef2cec7caa35d
F2F-00002-A-0015,5d3ac306a6992471b7c97976
F2F-00002-A-0015,5d3ac307a6992471b7c97adc
F2F-00002-A-0015,5d3ac307a6992471b7c97a18`;

export default csvTemplate;
